module.exports = __webpack_public_path__ + "img/audit1.5efcdebd.png";